<template>
  <main
    :class="cn(['', `--overlay-${current ? 'active' : 'inactive'}`, `--template-${templateHandle}`])"
    :style="`--footer-height: ${footerHeight}px`"
  >
    <slot />
  </main>
</template>

<script lang="ts" setup>
import { bem } from '../../utils/classnames'
import { useAppInject } from '../../context/useAppContext'
import { useOverlayInject } from '../../context/useOverlayContext'

const cn = bem('layout-container')
const { footerHeight, templateHandle } = useAppInject()
const { current } = useOverlayInject()
</script>

<style lang="scss">
@import '~styles/base.scss';

.layout-container {
  --header-offset: 225px;
  min-height: calc(100vh - var(--footer-height) - var(--header-offset));
  position: relative;
  padding-top: var(--header-offset);
  padding-bottom: var(--header-offset);
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;

  &--template-index {
    padding-top: 0;
  }

  @include breakpoint(l) {
    --header-offset: 125px;
  }

  .shopify-section {
    display: contents;
  }
}
</style>
